import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export const AllProducts = ({
  onCategorySelect,
  onBack
}) => {
  return <div className="flex flex-col p-6 flex-grow" data-id="element-87">
      <div className="flex items-center mb-6" data-id="element-88">
        <button onClick={onBack} className="mr-4" data-id="element-89">
          <ChevronLeftIcon size={24} data-id="element-90" />
        </button>
      </div>
      <h1 className="text-2xl font-bold mb-2" data-id="element-91">Pinnacle products</h1>
      <p className="text-gray-700 mb-6" data-id="element-92">Find the product you need</p>
      <div className="border rounded-lg p-4 mb-4 cursor-pointer" onClick={() => onCategorySelect('checking')} data-id="element-93">
        <div className="flex justify-between items-center" data-id="element-94">
          <div data-id="element-95">
            <h3 className="font-bold text-[#5c5cf5]" data-id="element-96">Checking Accounts</h3>
            <p className="text-gray-700" data-id="element-97">
              No minimum balances, access early direct deposit, and earn rewards
            </p>
          </div>
          <ChevronRightIcon className="text-[#5c5cf5]" data-id="element-98" />
        </div>
      </div>
      <div className="border rounded-lg p-4 mb-4 cursor-pointer" onClick={() => onCategorySelect('savings')} data-id="element-99">
        <div className="flex justify-between items-center" data-id="element-100">
          <div data-id="element-101">
            <h3 className="font-bold text-[#5c5cf5]" data-id="element-102">Saving Accounts</h3>
            <p className="text-gray-700" data-id="element-103">
              Options start with as little as $5, no minimum balance, and no
              fees
            </p>
          </div>
          <ChevronRightIcon className="text-[#5c5cf5]" data-id="element-104" />
        </div>
      </div>
      <div className="border rounded-lg p-4 mb-4 cursor-pointer" onClick={() => onCategorySelect('loans')} data-id="element-105">
        <div className="flex justify-between items-center" data-id="element-106">
          <div data-id="element-107">
            <h3 className="font-bold text-[#5c5cf5]" data-id="element-108">Loans</h3>
            <p className="text-gray-700" data-id="element-109">Start your loan application today</p>
          </div>
          <ChevronRightIcon className="text-[#5c5cf5]" data-id="element-110" />
        </div>
      </div>
      <div className="border rounded-lg p-4 mb-4 cursor-pointer" onClick={() => onCategorySelect('certificates')} data-id="element-111">
        <div className="flex justify-between items-center" data-id="element-112">
          <div data-id="element-113">
            <h3 className="font-bold text-[#5c5cf5]" data-id="element-114">Certificate of Deposit</h3>
            <p className="text-gray-700" data-id="element-115">Great rates on fixed-term deposits.</p>
          </div>
          <ChevronRightIcon className="text-[#5c5cf5]" data-id="element-116" />
        </div>
      </div>
    </div>;
};